import { MessageType } from "@/utils/message";

// 初始化状态
const initState = {
  // antd轻提示(兼容360浏览器)
  message: {
    txt: "",
    type: "info",
    duration: 3,
  } as MessageType,
  // 所有图片点击预览查看大图
  lookBigImg: {
    url: "",
    show: false,
  },
};

// 定义 action 类型
type Props =
  | { type: "layout/message"; payload: MessageType }
  | { type: "layout/lookBigImg"; payload: { url: string; show: boolean } };
// 频道 reducer
export default function loginReducer(state = initState, action: Props) {
  switch (action.type) {
    // antd轻提示(兼容360浏览器)
    case "layout/message":
      return { ...state, message: action.payload };
    // 所有图片点击预览查看大图
    case "layout/lookBigImg":
      return { ...state, lookBigImg: action.payload };
    default:
      return state;
  }
}
